export default {
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electrónico',
    password: 'Contraseña',
    password2: 'Repetir contraseña',
    phone: 'Teléfono',
    cellphone: 'Celular'
}